module.exports = __webpack_public_path__ + "static/media/no_items_icon.00c52ebb.png";